import MobileProfilePageHeader from './mobile-profile-page-header';

export default MobileProfilePageHeader;
